/**
 * Get icon path for product option values
 */
export function getOptionIcon(optionId: string, valueId: string, metadata?: any): string | null {
  const normalizedOptionId = String(optionId || '').toLowerCase();
  const normalizedValueId = String(valueId || '').toLowerCase();

  // Size/Format - based on orientation
  if (normalizedOptionId === 'size' && metadata?.orientation) {
    switch (metadata.orientation) {
      case 'landscape':
        return '/icons/orientation/landscape.svg';
      case 'portrait':
        return '/icons/orientation/portrait.svg';
      case 'square':
        return '/icons/orientation/square.svg';
    }
  }

  if (normalizedOptionId === 'shape' || normalizedOptionId === 'shape_type' || normalizedOptionId === 'custom_shape') {
    if (normalizedValueId.includes('round') || normalizedValueId.includes('circle')) {
      return '/icons/shapes/round.svg';
    }
    if (normalizedValueId.includes('rounded_corners') || normalizedValueId.includes('rounded-corners')) {
      return '/icons/shapes/rounded-corners.svg';
    }
    if (normalizedValueId.includes('hexagon')) {
      return '/icons/shapes/hexagon.svg';
    }
    if (normalizedValueId.includes('square')) {
      return '/icons/shapes/square.svg';
    }
    if (normalizedValueId.includes('heart')) {
      return '/icons/shapes/heart.svg';
    }
    if (normalizedValueId.includes('star')) {
      return '/icons/shapes/star.svg';
    }
    if (normalizedValueId.includes('cloud')) {
      return '/icons/shapes/cloud.svg';
    }
    if (normalizedValueId.includes('custom')) {
      return '/icons/shapes/custom-contour.svg';
    }
  }

  // Frame thickness
  if (normalizedOptionId === 'frame') {
    if (valueId.includes('18mm')) {
      return '/icons/frame/18mm.svg';
    }
    if (valueId.includes('38mm')) {
      return '/icons/frame/38mm.svg';
    }
  }

  // Material
  if (normalizedOptionId === 'material') {
    if (normalizedValueId.includes('gr_') || normalizedValueId.includes('silk') || normalizedValueId.includes('matt') || normalizedValueId.includes('paper') || normalizedValueId.includes('papier')) {
      return '/icons/material/paper.svg';
    }
    if (normalizedValueId.includes('canvas') || normalizedValueId.includes('textile') || normalizedValueId.includes('plush') || normalizedValueId.includes('2way')) {
      return '/icons/material/canvas-indoor.svg';
    }
    if (normalizedValueId.includes('pvc') || normalizedValueId.includes('510gr') || normalizedValueId.includes('frontlit')) {
      return '/icons/material/pvc-outdoor.svg';
    }
  }

  if (normalizedOptionId === 'usage') {
    if (normalizedValueId.includes('inside') || normalizedValueId.includes('indoor')) {
      return '/icons/material/canvas-indoor.svg';
    }
    if (normalizedValueId.includes('outside') || normalizedValueId.includes('outdoor')) {
      return '/icons/material/pvc-outdoor.svg';
    }
  }

  if (normalizedOptionId === 'fold') {
    switch (valueId) {
      case 'single_4':
        return '/icons/fold/single-vertical.svg';
      case 'singlehorizontal_4':
        return '/icons/fold/single-horizontal.svg';
      case 'wikkel_6':
      case 'zigzag_6':
      case 'luik_6':
        return '/icons/fold/tri-fold.svg';
      case 'wikkel_8':
      case 'zigzag_8':
      case 'luik_8':
        return '/icons/fold/four-panel.svg';
      case 'cross_8':
        return '/icons/fold/cross-fold.svg';
      case 'wikkel_10':
      case 'zigzag_10':
        return '/icons/fold/five-panel.svg';
    }
  }

  // Hanging system
  if (normalizedOptionId === 'accessories_frames') {
    if (normalizedValueId === 'none') {
      return '/icons/hanging/none.svg';
    }
    if (normalizedValueId.includes('_2') || normalizedValueId.includes('extra')) {
      return '/icons/hanging/double.svg';
    }
    return '/icons/hanging/single.svg';
  }

  // Delivery/Urgency
  if (normalizedOptionId === 'urgency') {
    switch (valueId) {
      case 'standard':
        return '/icons/delivery/standard.svg';
      case 'moderate':
        return '/icons/delivery/moderate.svg';
      case 'quick':
        return '/icons/delivery/quick.svg';
      case 'urgent':
        return '/icons/delivery/urgent.svg';
    }
  }

  return null;
}

/**
 * Check if an option type should display icons
 */
export function shouldShowIcons(optionId: string): boolean {
  return ['size', 'frame', 'material', 'usage', 'accessories_frames', 'urgency', 'fold', 'shape', 'shape_type', 'custom_shape'].includes(String(optionId || '').toLowerCase());
}
